import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OperationDetailsTableItem } from './operations-details-table.interface';
import { FwIconColor } from '../../../shared/types/fw-icon-color.type';

@Component({
  host: { 'test-id': 'operations-details-table' },
  selector: 'operations-details-table',
  styleUrls: ['./operations-details-table.component.scss'],
  templateUrl: './operations-details-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationsDetailsTable {
  @Input() tableConfig: OperationDetailsTableItem[];
  @Input() icon: string;
  @Input() title: string;
  @Input() iconColor: FwIconColor = 'primary';
  @Input() isWithTotal = false;
  @Input() isSmall = false;

  get total(): number {
    return this.tableConfig.reduce((acc, curr) => acc + curr.count, 0);
  }

  protected isShowCount(value: number): boolean {
    if (isNaN(value)) {
      return false;
    }

    return typeof value === 'number';
  }
}
